import MainComponent from "./pages/ZooPage";

function App() {
  return <MainComponent />;
}

export default App;
